import { useLanguage } from "@/contexts/LanguageContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { FilePdf, WhatsappLogo, CheckCircle, Package, CalendarBlank } from "@phosphor-icons/react";
import ExportTemplateConfig from "@/components/ExportTemplateConfig";
import ExportSelectorDialog from "@/components/ExportSelectorDialog";
import ShoppingListBuilderDialog from "@/components/ShoppingListBuilderDialog";
import { formatCurrency } from "@/pages/sheetUtils";

export default function ShoppingExportModals(props) {
  const { t } = useLanguage();
  const { activeTab, diagResult, runningDiag, setActiveTab, setShowBuilder, setShowDiag, setShowExportSelector, setShowTemplateConfig, showBuilder, showDiag, showExportSelector, showTemplateConfig } = props;
  return (
    <>
        <ExportTemplateConfig open={showTemplateConfig} onClose={() => setShowTemplateConfig(false)} />
        <ExportSelectorDialog open={showExportSelector} onClose={() => setShowExportSelector(false)} type="lista_compras" />
        <ShoppingListBuilderDialog open={showBuilder} onClose={() => setShowBuilder(false)} />

        <Dialog open={showDiag} onOpenChange={setShowDiag}>
          <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="shopping-diag-dialog">
            <DialogHeader>
              <DialogTitle>Diagnóstico da Lista de Compras</DialogTitle>
              <DialogDescription>
                Testa todo o fluxo no servidor com os seus dados reais e mostra onde falha.
              </DialogDescription>
            </DialogHeader>
            {runningDiag ? (
              <div className="flex items-center gap-3 py-6 justify-center text-zinc-500">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-zinc-900" />
                Executando diagnóstico...
              </div>
            ) : diagResult ? (
              <div className="space-y-2">
                <p className={`text-sm font-semibold ${diagResult.all_ok ? "text-emerald-700" : "text-red-700"}`} data-testid="diag-overall">
                  {diagResult.all_ok ? "✅ Tudo funcionando neste ambiente" : "❌ Falha encontrada — envie um print desta tela"}
                </p>
                {(diagResult.steps || []).map((s, i) => (
                  <div key={s.step || i} className={`rounded-md border p-3 text-sm ${s.ok ? "border-emerald-200 bg-emerald-50" : "border-red-300 bg-red-50"}`} data-testid={`diag-step-${i}`}>
                    <p className="font-medium">
                      {s.ok ? "✅" : "❌"} {s.step} {typeof s.ms === "number" ? `(${s.ms}ms)` : ""}
                    </p>
                    {s.info && <p className="text-zinc-600 mt-0.5">{s.info}</p>}
                    {s.error && <p className="text-red-700 font-mono text-xs mt-1 break-all">{s.error}</p>}
                    {s.traceback && (
                      <pre className="text-[10px] text-red-800 bg-red-100 rounded p-2 mt-1 whitespace-pre-wrap break-all max-h-48 overflow-y-auto">{s.traceback}</pre>
                    )}
                  </div>
                ))}
              </div>
            ) : null}
          </DialogContent>
        </Dialog>


    </>
  );
}
